const FETCH_INK_MANUFACTURERS = 'FETCH_INK_MANUFACTURERS';
const FETCH_INK_MANUFACTURERS_FULFILLED = 'FETCH_INK_MANUFACTURERS_FULFILLED';
const FETCH_INK_MANUFACTURERS_REJECTED = 'FETCH_INK_MANUFACTURERS_REJECTED';
const FETCH_INK_MODELS = 'FETCH_INK_MODELS';
const FETCH_INK_MODELS_FULFILLED = 'FETCH_INK_MODELS_FULFILLED';
const FETCH_INK_MODELS_REJECTED = 'FETCH_INK_MODELS_REJECTED';
const TOGGLE_INK_WIDGET = 'TOGGLE_INK_WIDGET';

export {
  FETCH_INK_MANUFACTURERS,
  FETCH_INK_MANUFACTURERS_FULFILLED,
  FETCH_INK_MANUFACTURERS_REJECTED,
  FETCH_INK_MODELS,
  FETCH_INK_MODELS_FULFILLED,
  FETCH_INK_MODELS_REJECTED,
  TOGGLE_INK_WIDGET,
};
